import { animate, state, style, transition, trigger } from '@angular/animations';

/**
 * Animation for showing/hiding input errors (inline feedback).
 */
export const inputErrorAnimation = trigger('inputError', [
	state('valid', style({ borderColor: '#949494', backgroundColor: 'white', borderWidth: '1px' })),
	state('invalid', style({ borderColor: '#d1002a', backgroundColor: '#fee', borderWidth: '2px' })),
	transition('valid => invalid', animate(`50ms 300ms ease-out`)),
	transition('invalid => valid', animate(`50ms ease-out`))
]);
